var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(!_vm.ready)?_c('v-progress-circular',{staticClass:"mt-2",attrs:{"indeterminate":"","color":"primary","size":"100"}}):_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.iFrameUrl,"frameBorder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }